export default __webpack_public_path__ + "static/invimaticColorLogo-ab664675836d02abfe749657183c6862.svg";